// import React, { useState, useEffect } from "react";
// import { GetInvestors, GetInvestorsByPark } from "../../CommonData/CommonData";
// import { ParkList } from "../../PreRenderedComponents";
// import { IPDCReportTemplate } from "../../../../../components";
// import { Grid, CircularProgress, Button } from "@mui/material";
// import { Search } from "@mui/icons-material";
// import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

// export default function InvestorListAll() {
//   const [data, setData] = useState([]);
//   const [selectedPark, setSelectedPark] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const decodedUser = useDecodedUser();

//   // Function to fetch all investors
//   const fetchAllInvestors = async () => {
//     try {
//       setLoading(true);
//       let allInvestors = await GetInvestors();
//       // Remove any geometry or sensitive data if needed
//       const filteredInvestors = allInvestors?.map(({ geometry, ...rest }) => rest);
//       filteredInvestors && filteredInvestors?.length > 0
//         ? setData(filteredInvestors)
//         : setData([]);
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   // Function to search investors by selected park
//   const fetchInvestorsByPark = async () => {
//     try {
//       setLoading(true);
//       if (selectedPark) {
//         let investorsByPark = await GetInvestorsByPark(selectedPark?.id);
//         // Remove any geometry or sensitive data if needed
//         const filteredInvestors = investorsByPark?.map(({ geometry, ...rest }) => rest);
//         filteredInvestors && filteredInvestors?.length > 0
//           ? setData(filteredInvestors)
//           : setData([]);
//       }
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   // Fetch all investors when component mounts
//   useEffect(() => {
//     fetchAllInvestors();
//   }, []); // Empty dependency array = runs once on mount

//   if (loading) return <CircularProgress />;
  
//   return (
//     <>
//       <Grid container className="no-print" spacing={2} ml={1} mb={2}>
//         <Grid item xs={12} md={6}>
//           <ParkList
//             selectedPark={selectedPark}
//             setSelectedPark={setSelectedPark}
//           />
//         </Grid>
//         <Grid item xs={12} md={3}>
//           <Button
//             startIcon={<Search />}
//             onClick={fetchInvestorsByPark}
//             variant="contained"
//             color="primary"
//             fullWidth={true}
//           >
//             Search
//           </Button>
//         </Grid>
//       </Grid>
//       <>
//         {data && data?.length > 0 ? (
//           <IPDCReportTemplate
//             data={data}
//             setData={setData}
//             defaultTitle="Investors List"
//             isEditable={false}
//             isPrintable={false}
//             showWhatToDisplay={true}
//           />
//         ) : (
//           <div>No Investors Found</div>
//         )}
//       </>
//     </>
//   );
// }
//**************************************Export Button is added */
import React, { useState, useEffect } from "react";
import { GetInvestors, GetInvestorsByPark } from "../../CommonData/CommonData";
import { ParkList } from "../../PreRenderedComponents";
import { IPDCReportTemplate } from "../../../../../components";
import { Grid, CircularProgress, Button, Box } from "@mui/material";
import { Search, TableChart } from "@mui/icons-material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
import * as XLSX from "xlsx";

export default function InvestorListAll() {
  const [data, setData] = useState([]);
  const [selectedPark, setSelectedPark] = useState(null);
  const [loading, setLoading] = useState(false);
  const decodedUser = useDecodedUser();

  // Function to fetch all investors
  const fetchAllInvestors = async () => {
    try {
      setLoading(true);
      let allInvestors = await GetInvestors();
      // Remove any geometry or sensitive data if needed
      const filteredInvestors = allInvestors?.map(({ geometry, ...rest }) => rest);
      filteredInvestors && filteredInvestors?.length > 0
        ? setData(filteredInvestors)
        : setData([]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Function to search investors by selected park
  const fetchInvestorsByPark = async () => {
    try {
      setLoading(true);
      if (selectedPark) {
        let investorsByPark = await GetInvestorsByPark(selectedPark?.id);
        // Remove any geometry or sensitive data if needed
        const filteredInvestors = investorsByPark?.map(({ geometry, ...rest }) => rest);
        filteredInvestors && filteredInvestors?.length > 0
          ? setData(filteredInvestors)
          : setData([]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Fetch all investors when component mounts
  useEffect(() => {
    fetchAllInvestors();
  }, []);

  // Export to Excel functionality
  const handleExportExcel = () => {
    if (!data || data.length === 0) return;
    
    const exportData = data.map(item => {
      const cleanItem = { ...item };
      Object.keys(cleanItem).forEach(key => {
        if (cleanItem[key] && typeof cleanItem[key] === 'object') {
          cleanItem[key] = JSON.stringify(cleanItem[key]);
        }
      });
      return cleanItem;
    });
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Investors");
    XLSX.writeFile(wb, "investors_list.xlsx");
  };

  if (loading) return <CircularProgress />;
  
  return (
    <>
      <Grid container className="no-print" spacing={2} ml={1} mb={2} alignItems="center">
        <Grid item xs={12} md={5}>
          <ParkList
            selectedPark={selectedPark}
            setSelectedPark={setSelectedPark}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Button
            startIcon={<Search />}
            onClick={fetchInvestorsByPark}
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            sx={{ textTransform: 'none' }}
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={12} md={4} display="flex" justifyContent="flex-end" pr={6}>
          <Button
            startIcon={<TableChart />}
            onClick={handleExportExcel}
            variant="contained"
            color="success"
            size="small"
            sx={{ textTransform: 'none' }}
          >
            Export to Excel
          </Button>
        </Grid>
      </Grid>
      <>
        {data && data?.length > 0 ? (
          <IPDCReportTemplate
            data={data}
            setData={setData}
            defaultTitle="Investors List"
            isEditable={false}
            isPrintable={false}
            showWhatToDisplay={true}
          />
        ) : (
          <div>No Investors Found</div>
        )}
      </>
    </>
  );
}